import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { useTranslation } from 'react-i18next';
import { TextWrapper } from '../../../components/FlightDetails/TextWrapper.js';
import { Flex, Notice } from '../../../primitives/index.js';
import { qaId } from '../../../utils/index.js';
import { FLIGHT_DETAILS_QA_ID } from '../../../utils/qaId.js';
export const Footer = ({
  date,
  dateLabel,
  duration,
  durationLabel,
  highlightDate = false
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  return _jsxs(Flex, {
    direction: "column",
    spacing: "24px",
    "data-testid": qaId(FLIGHT_DETAILS_QA_ID, 'footer'),
    children: [_jsxs(Flex, {
      spacing: "8px",
      children: [_jsx(Notice, {
        variant: "warning",
        children: _jsxs(Flex, {
          spacing: "8px",
          direction: "row",
          flexWrap: "wrap",
          children: [_jsx(Text, {
            preset: "paragraphMediumBold",
            color: 'inherit',
            children: dateLabel
          }), _jsx(Text, {
            preset: "labelSmall",
            color: 'inherit',
            children: _jsx(TextWrapper, {
              highlighted: highlightDate,
              children: date
            })
          })]
        })
      }), _jsxs(Flex, {
        spacing: "8px",
        direction: "row",
        padding: ['0px', '8px'],
        flexWrap: "wrap",
        children: [_jsx(Text, {
          preset: "paragraphMediumBold",
          children: durationLabel
        }), _jsx(Text, {
          preset: "labelSmall",
          "data-testid": "shared-flightLayer-tripDuration",
          color: "contentSecondary",
          children: duration
        })]
      })]
    }), _jsx(Notice, {
      variant: "info",
      children: t('flightHint')
    })]
  });
};